import { Card, CardContent, Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../../constants/routes';
import { CardItem } from '../../../types/common';

interface ITemplateCardProps {
  name: CardItem['name'];
  description: CardItem['description'];
  icon: CardItem['icon'];
  id: CardItem['id'];
  url: CardItem['url']
}

const TemplateCard: React.FC<ITemplateCardProps> = ({ name, description, icon, id, url }) => {
  const theme = useTheme();

  const navigate = useNavigate();
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: '12px',
        '&:hover': {
          transition: 'all 120ms linear',
          background: theme.custom.palette.primary.default,
          color: theme.custom.palette.primary.white,
          cursor: 'pointer',
          boxShadow: theme.custom.palette.shadow.default,
        },
      }}
      onClick={() => navigate(`${PATHS.generator}/${url}`)}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Stack
          sx={{
            height: '60px',
            fontSize: '38px',
            justifyContent: 'center',
          }}
        >
          {icon}
        </Stack>

        <Typography variant="h3">{name}</Typography>

        <Typography>{description}</Typography>
      </CardContent>
    </Card>
  );
};

export default TemplateCard;
